
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="col-md-12">
        <div class="form-group">
          <div style="    display: grid;    grid-template-columns: 200px auto;    gap: 15px;">
            <div style="position: relative;">
              <label>Name your Automation</label>
            </div>
            <div style="position: relative;">
              <input type="text" name="connectionName" formControlName="connectionName" placeholder="Automation Name" (focus)="onFocusEvent($event)"   class="form-control" [ngClass]="{ 'is-invalid':  submitted && f.connectionName.errors }"  />
              <div *ngIf="submitted && f.connectionName.errors" class="invalid-feedback">
                <div *ngIf="f.connectionName.errors.required">Automation name is required</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--<div class="col-md-12">
        <div class="form-group">
          <button class="btn btn-primary">
           
            Save
          </button>
         
        </div>
        </div>-->
</form>

